module.exports = __webpack_public_path__ + "img/foto-escritorio-6.3011c8d8.png";